import { render, staticRenderFns } from "./SaveSearch.vue?vue&type=template&id=1756ad6d&scoped=true&"
import script from "./SaveSearch.vue?vue&type=script&lang=js&"
export * from "./SaveSearch.vue?vue&type=script&lang=js&"
import style0 from "./SaveSearch.vue?vue&type=style&index=0&id=1756ad6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1756ad6d",
  null
  
)

/* custom blocks */
import block0 from "./SaveSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports